module.exports = __webpack_public_path__ + "img/ss_pink-03.3685fd59.jpg";